import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=e1c1f50a&scoped=true"
import script from "./_id.vue?vue&type=script&lang=ts"
export * from "./_id.vue?vue&type=script&lang=ts"
import style0 from "./_id.vue?vue&type=style&index=0&id=e1c1f50a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1c1f50a",
  null
  
)

export default component.exports